import type { Nationality } from "@services/gatepass/types";
import { REFERENCE_DATA_TYPES } from "@services/referenceDataApi";
import { useFormattedReference } from "./useFormattedReference";

const RESTRICTED_NATIONALITIES_SERVICE = "bff-gatepass";

export const useRestrictedNationalities = () =>
  useFormattedReference<Nationality>(
    REFERENCE_DATA_TYPES.RESTRICTED_NATIONALITIES,
    RESTRICTED_NATIONALITIES_SERVICE,
  );
